import type { GenericParameters } from "~/core/models/GenericParameters.type";
import LxcError from "~/core/models/LxcError.class";
import type { GroupsUserDetail } from "~/modules/user/models/GroupUserDetail.interface";
import userGroupService from "~/modules/user/services/userGroup.service";

export function useGetUserGroup({ organizationCode }: GenericParameters) {
  const service =
    userGroupService.getOrganizationUserGroupByCode.bind(userGroupService);
  const isLoading = ref<boolean>(false);
  const error = ref<LxcError | null>(null);
  const result: Ref<GroupsUserDetail | undefined> = ref<
    GroupsUserDetail | undefined
  >(undefined);

  async function getUserGroup(groupName: string): Promise<void> {
    error.value = null;
    isLoading.value = true;
    result.value = undefined;

    if (!organizationCode) {
      throw new Error("Organization code is required");
    }
    const response = await service(organizationCode, groupName);

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = {
        ...response,
        users: response.users,
        sectorCodes:
          response.sectorCodes?.map((sector) => sector.toString()) ?? [],
      };
    }

    isLoading.value = false;
  }

  return {
    getUserGroup,
    error,
    isLoading,
    result,
  };
}
